import { BankPriceType, TenantOptionsDetails } from "features/types";
import i18n from "plugins/localization";
import { queryClient } from "plugins/queryClient";
import tinycolor from "tinycolor2";
import * as eva from "@eva-design/eva";
import { Platform } from "react-native";

export const generateThemeColor = (primaryColor: string) => {
  return {
    ...eva.light,
    "color-primary-active": tinycolor(primaryColor).darken(10).toString(),
    "color-primary-focus": tinycolor(primaryColor).darken(10).toString(),
    "color-primary-hover": tinycolor(primaryColor).darken(10).toString(),
    "color-primary-500": primaryColor,
  };
};

export const formatCurrency = (
  nullableAmount: string | number | null | undefined,
  options: {
    priceType?: BankPriceType;
    showPoints?: boolean; // if true, show the unit of points at the end of the formatted amount, if false, only show the amount
  } = {}
) => {
  const tenantConfig = queryClient.getQueryData<TenantOptionsDetails>([
    "fetchTenantConfiguration",
  ]);
  if (!tenantConfig) return 0;

  const { priceType = "CURRENCY", showPoints = true } = options;
  const { defaultCurrency, locale } = tenantConfig;
  const amount = nullableAmount || 0;

  if (priceType === "POINTS") {
    const amountAsNumber = amount as number;
    const formatted = new Intl.NumberFormat(locale, {
      style: "decimal",
    }).format(Number(amountAsNumber));
    return showPoints
      ? `${formatted} ${i18n.t("common.point", { count: amountAsNumber })}`
      : formatted;
  }

  // priceType is CURRENCY
  const formattedValue = new Intl.NumberFormat(locale, {
    style: "currency",
    currency: defaultCurrency,
  }).format(Number(amount));
  // if the currency is not USD, add the currency at the end. e.g. $125.00 CAD and 125,00 € EUR
  return defaultCurrency === "USD"
    ? formattedValue
    : `${formattedValue} ${defaultCurrency}`;
};

// https://stackoverflow.com/a/61251124
export const isRunningInWebView = () => {
  if (Platform.OS !== "web") return false;
  // @ts-ignore
  var standalone = window.navigator.standalone, // ios
    userAgent = window.navigator.userAgent.toLowerCase(),
    safari = /safari/.test(userAgent),
    ios = /iphone|ipod|ipad/.test(userAgent);
  if (ios) {
    if (!standalone && !safari) {
      // iOS webview
      return true;
    }
  } else {
    if (userAgent.includes("wv")) {
      // Android webview
      return true;
    }
  }
  return false;
};
